import {ExternalLink} from 'lucide-react'
import { explorerAddressUrl, isEthAddress, shortenAddress } from '@/lib/launchpad/contracts'

function ExplorerLink({
  address,
  label,
  className,
}: {
  address?: string
  label?: string
  className?: string
}) {
  if (!isEthAddress(address))
    return null

  return (
    <a
      href={explorerAddressUrl(address)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={event => event.stopPropagation()}
      className={className ?? 'inline-flex items-center gap-1 text-[11px] font-medium text-lime-400 hover:text-lime-300'}
      aria-label="View contract on Blockscout"
    >
      {label ?? shortenAddress(address)}
      <ExternalLink className="h-3 w-3" aria-hidden="true" />
    </a>
  )
}

export default ExplorerLink
